import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { FeatureKey } from '../../../../../shared/features';

const featureKeyToV2Route: Partial<Record<FeatureKey, string>> = {
  CONTACT_PROPERTY: '/contact',
  SCHEDULE_TOUR: '/schedule',
  CHAT_WITH_RESIDENT: '/',
  CHAT_ROOM: '/',
  MULTI_MESSAGE: '/',
  CREATE_ACCOUNT: '/auth/create',
  MORE: '/more',
};

export function useExternalFeatureListener() {
  const navigate = useNavigate();
  const navigateRef = useRef(navigate);
  navigateRef.current = navigate;

  useEffect(() => {
    const xprops = globalThis.xprops;
    if (!xprops) return;

    const handler = async () => {
      try {
        const { props, instanceId, key } = (await xprops.getEvent()) || {};

        if (instanceId !== xprops.instanceId) return;

        const route = featureKeyToV2Route[key as FeatureKey];

        if (route) {
          navigateRef.current(route, { state: props });
        }
      } catch (error) {
        console.log(error);
      }
    };

    xprops.addEventListener('feature', handler);
  }, []);
}
